export const cafeInfo = {
  name: "ChaiY",
  contact: {
    phone: "8080673114",
    email: "info@chaiy.com",
    address: "Dahanukar Colony, Kothrud, Pune, Maharashtra"
  },
  zomatoLink: "https://zomato.onelink.me/xqzv/i14k39jj", 
};

export const products = [
  {
    id: 1,
    name: "Classic Masala Chai Premix",
    description: "Traditional blend of premium tea leaves with authentic Indian spices.",
    image: "https://budleaf.com/wp-content/uploads/2024/09/Masala-Chai-Vs-Chai-Latte-2048x1365.jpeg",
  },
  {
    id: 2,
    name: "Ginger Chai Premix",
    description: "Invigorating blend with fresh ginger and aromatic spices.",
    image: "https://moonrice.net/wp-content/uploads/2023/08/Chai-05.jpg",
  },
  {
    id: 3,
    name: "Cardamom Chai Premix",
    description: "Delicate cardamom-infused tea for a royal experience.",
    image: "https://moonrice.net/wp-content/uploads/2023/08/Chai-06.jpg",
  }
];